import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiCoefficyService {

  public url: string;
  constructor(private http: HttpClient) {
    this.url = environment.backend;
  }

  public getFormData(q) {
    return this.http.get(`${this.url}/coefficy/autocomplete/` + q);
  }

  public visitIdentification(visitRandomId, companyIdentifier) {
    const body = {
      visitRandomId,
      companyIdentifier
    };
    return new Promise ((resolve, reject) => {
      this.http
        .post(this.url + '/coefficy/visit/identify', body)
        .subscribe(
          (identification) => {
            resolve(identification);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

}
